// CLOSE SIDEBAR ON CLICKING THE CLOSE ICON
document
  .querySelector(".deareco-close-icon")
  .addEventListener("click", function () {
    // Get the details element by its ID
    var detailsElement = document.getElementById(
      "Details-menu-drawer-container"
    );

    var SummaryElement = document.getElementById("Detail-menu-summary");

    // Close the details element after 300ms same as css transition
    setTimeout(function(){
      detailsElement.open = false;
    },300);
    
    detailsElement.classList.remove("menu-opening");

    // Close SummaryElement
    SummaryElement.setAttribute("aria-expanded", false);

    // Remove overhidden class
    document.querySelector("body").classList.remove("overflow-hidden-desktop");
  });

// SIDE BAR ACCORDION SCRIPT
function openTab(event, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabName).style.display = "flex";
  event.currentTarget.className += " active";
}

// SIDE BAR ACCORDION SCRIPT
var acc = document.getElementsByClassName("sidebar-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
